import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container relative" }
const _hoisted_2 = { class: "grid md:grid-cols-12 grid-cols-1 gap-[30px] mb-40" }
const _hoisted_3 = { class: "lg:col-span-4 md:col-span-6" }
const _hoisted_4 = {
  class: "title text-center",
  "data-aos": "fade-right",
  "data-aos-duration": "500"
}
const _hoisted_5 = { class: "mt-20 text-left" }
const _hoisted_6 = {
  class: "lg:col-span-8 md:col-span-6",
  "data-aos": "fade-left",
  "data-aos-duration": "500"
}
const _hoisted_7 = { class: "lg:ms-5" }
const _hoisted_8 = { class: "bg-white dark:bg-slate-900 rounded-md shadow dark:shadow-gray-800 p-6" }
const _hoisted_9 = { class: "grid lg:grid-cols-12 gap-3" }
const _hoisted_10 = { class: "lg:col-span-12" }
const _hoisted_11 = { class: "text-start" }
const _hoisted_12 = { class: "lg:col-span-12" }
const _hoisted_13 = { class: "text-start" }
const _hoisted_14 = { class: "lg:col-span-12" }
const _hoisted_15 = { class: "text-start" }
const _hoisted_16 = { class: "lg:col-span-12" }
const _hoisted_17 = { class: "text-start" }
const _hoisted_18 = { class: "lg:col-span-12" }
const _hoisted_19 = { class: "lg:col-span-12" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  key: 0,
  class: "lg:col-span-12 p-4 text-sm text-gray-800 rounded-lg bg-gray-50 dark:bg-gray-800 dark:text-gray-300",
  role: "alert"
}

import {openMail} from "@/utils/mail";
import {onBeforeUnmount, onMounted, ref} from "vue";

import {FriendlyCaptchaSDK, type WidgetHandle} from '@friendlycaptcha/sdk';

import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

const siteKey = 'FCMR1UH0SBUCFVGJ';

export default /*@__PURE__*/_defineComponent({
  __name: 'contact',
  setup(__props) {

const token = ref('');
// Eine Friendly-Captcha-Antwort ist nur einmal gültig; nach dem Senden wird das Widget zurückgesetzt.
const captchaEl = ref<HTMLElement | null>(null);
let widget: WidgetHandle | null = null;

onMounted(() => {
   const el = captchaEl.value;
   if (!el) return;

   // Die Events werden auf dem Widget-Element ausgelöst.
   el.addEventListener('frc:widget.complete', (event) => {
      token.value = (event as CustomEvent<{ response: string }>).detail.response;
   });
   for (const name of ['frc:widget.expire', 'frc:widget.error', 'frc:widget.reset']) {
      el.addEventListener(name, () => {
         token.value = '';
      });
   }

   widget = new FriendlyCaptchaSDK().createWidget({
      element: el,
      sitekey: siteKey,
      apiEndpoint: 'global',
      language: 'de',
   });
});

onBeforeUnmount(() => widget?.destroy());

const name = ref('');
const email = ref('');
const subject = ref('');
const message = ref('');
const progress = ref(false);
const success = ref('');

async function sendMail() {
   progress.value = true;
   success.value = '';

   try {
      const response = await fetch('api/send-mail.php', {
         method: 'POST',
         headers: {
            'Content-Type': 'application/json',
         },
         body: JSON.stringify({
            name: name.value,
            email: email.value,
            subject: subject.value,
            message: message.value,
            token: token.value,
         }),
      });
      const data = await response.json();

      if (data.success) {
         name.value = '';
         email.value = '';
         subject.value = '';
         message.value = '';
         success.value = 'E-Mail erfolgreich versendet.';
      } else {
         success.value = 'E-Mail konnte nicht versendet werden!';
      }
   } catch (error) {
      console.error('FAILED...', error);
      success.value = 'E-Mail konnte nicht versendet werden!';
   } finally {
      progress.value = false;
      token.value = '';
      widget?.reset();
   }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[7] || (_cache[7] = _createElementVNode("h4", { class: "font-anaheim font-semibold text-4xl mb-3" }, "Kontakt", -1)),
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "border" }, null, -1)),
          _createElementVNode("p", _hoisted_5, [
            _cache[5] || (_cache[5] = _createTextVNode(" Ihr könnt uns eine Nachricht über das Kontaktformular senden oder direkt an die ")),
            _createElementVNode("a", {
              href: "#",
              class: "encrypted-mail font-semibold",
              "data-name": "kontakt",
              "data-domain": "bogenschuetzen-muenster",
              "data-tld": "de",
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_unref(openMail) && _unref(openMail)(...args)), ["prevent"]))
            }),
            _cache[6] || (_cache[6] = _createTextVNode(" mailen. "))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("form", {
              id: "contact-form",
              ref: "form",
              onSubmit: _withModifiers(sendMail, ["prevent"])
            }, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _withDirectives(_createElementVNode("input", {
                      name: "name",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((name).value = $event)),
                      type: "text",
                      placeholder: "Name",
                      required: "",
                      class: "form-input mt-1 w-full py-2 px-3 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-100 focus:border-yellow-500 dark:border-gray-800 dark:focus:border-red-500 focus:ring-0"
                    }, null, 512), [
                      [_vModelText, name.value]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _withDirectives(_createElementVNode("input", {
                      name: "email",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((email).value = $event)),
                      type: "email",
                      placeholder: "Email",
                      required: "",
                      class: "form-input mt-1 w-full py-2 px-3 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-100 focus:border-yellow-500 dark:border-gray-800 dark:focus:border-red-500 focus:ring-0"
                    }, null, 512), [
                      [_vModelText, email.value]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _withDirectives(_createElementVNode("input", {
                      name: "subject",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((subject).value = $event)),
                      placeholder: "Betreff",
                      required: "",
                      class: "form-input mt-1 w-full py-2 px-3 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-100 focus:border-yellow-500 dark:border-gray-800 dark:focus:border-red-500 focus:ring-0"
                    }, null, 512), [
                      [_vModelText, subject.value]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _withDirectives(_createElementVNode("textarea", {
                      name: "message",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((message).value = $event)),
                      placeholder: "Nachricht",
                      required: "",
                      class: "form-input mt-1 w-full py-2 px-3 h-80 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-100 focus:border-yellow-500 dark:border-gray-800 dark:focus:border-red-500 focus:ring-0"
                    }, "\t\t                         ", 512), [
                      [_vModelText, message.value]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", {
                    ref_key: "captchaEl",
                    ref: captchaEl,
                    class: "frc-captcha"
                  }, null, 512)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("button", {
                    type: "submit",
                    id: "submit",
                    name: "send",
                    class: _normalizeClass(["py-2 px-5 tracking-wider inline-flex items-center justify-center font-medium rounded bg-yellow-500 text-black", { 'btn-disabled': !token.value || progress.value }]),
                    disabled: !token.value || progress.value
                  }, [
                    (progress.value)
                      ? (_openBlock(), _createBlock(_unref(FontAwesomeIcon), {
                          key: 0,
                          icon: "fa-solid fa-circle-notch",
                          spin: "",
                          class: "mr-2"
                        }))
                      : _createCommentVNode("", true),
                    _cache[9] || (_cache[9] = _createElementVNode("span", null, "Send Message", -1))
                  ], 10, _hoisted_20)
                ]),
                (success.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(success.value), 1))
                  : _createCommentVNode("", true)
              ])
            ], 544)
          ])
        ])
      ])
    ])
  ]))
}
}

})